export const topic = {
  KAFKA_TOPIC: {
    UPDATE_TRIP_SOURCE_OUT: "updateTripSourceOut",
    REMOVE_DESTINATION_IN: "removeDestiationIn",
    CREATE_INDENT: "createIndent",
    EDIT_INDENT: "editIndent",
    CREATE_PARTNER_COMMENT: "createPartnerComment",
    POD_RECEIPT_VERIFICATION: "podReceiptVerification",
    INSERT_TRIP_RATING: "insertTripRating",
    UPDATE_CITY_IFSC: "updateCityIfsc",
    REJECT_CREDIT_DEBIT: "rejectCreditDebit",
    REJECT_PARTNER_BANK: "rejectPartnerBank",
    DELETE_PARTNER_BANK: "deletePartnerBank",
    UPDATE_EMPLOYEE_TICKET_PORTAL: "updateEmployeeTicketPortal",
    EMPLOYEE_CLAIM_REQUEST: "employeeClaimRequest",
    CREATE_EMPLOYEE_CLAIM_COMMENT: "createEmployeeClaimComment",
    MANAGER_APPROVE_EMPLOYEE_CLAIM: "managerApproveEmployeeClaim",
    REJECT_EMPLOYEE_CLAIM: "rejectEmployeeClaim",
    CANCEL_EMPLOYEE_LEAVE: "cancelEmployeeLeave",
    CREATE_LEAVE_BALANCE: "createLeaveBalance",
    CREATE_BILLING_REMARKS: "createBillingRemarks",
    UPDATE_END_CUSTOMER_LOADING_POINT: "UpdateEndCustomerLoadingPoint",
    UPDATE_END_CUSTOMER_UNLOADING_POINT: "UpdateEndCustomerUnloadingPoint",
    UPDATE_TRIP_DRIVER: "updateTripDriver",
    CANCEL_INDENT: "cancelIndent",
    MANAGER_APPROVE_EMPLOYEE_RESIGNATION: "managerApproveEmployeeResignation",
    CREATE_HOUSE_BANK_DOWNTIME: "createHouseBankDowntime",
    CREATE_HOUSE_BANK_UPTIME: "createHouseBankUptime",
    UPDATE_EMPLOYEE_ADMIN_TICKET_PORTAL: "updateEmployeeAdminTicketPortal",
    UPDATE_EMPLOYEE_TRACK_ACCESS: "updateEmployeeTrackAccess",
    UPDATE_EMPLOYEE_TEAM: "updateEmployeeTeam",
    CREATE_PARTNER_LEAD: "createPartnerLead",
    INSERT_PARTNER_USER: "insertPartnerUser",
    EDIT_TRUCK_NO: "editTruckNo",
    EMPLOYEE_RESIGNATION_REQUEST: "employeeResignationRequest",
    REJECT_EMPLOYEE_RESIGNATION: "rejectEmployeeResignation",
    CREATE_EMPLOYEE_LEAVE: "createEmployeeLeave",
    TRIP_DOUT_REMOVAL: "tripDoutRemoval",
    SUBMIT_PARTNER_KYC: "submitPartnerKyc",
    UPDATE_PARTNER_ADMIN_USER: "updatePartnerAdminUser",
    CONVERT_REJECTED_PARTNER_LEAD: "convertRejectedPartnerLead",
    REJECT_PARTNER_LEAD: "rejectPartnerLead",
    PARTNER_DEACTIVATION_TO_ACTIVATION: "partnerDeactivationToActivation",
    PARTNER_ACTIVATION_TO_DEACTIVATION: "partnerActivationToDeactivation",
    REJECT_PARTNER_KYC: "rejectPartnerKyc",
    UPDATE_EMPLOYEE_FUNCTION_BRANCH_TEAM: "updateEmployeeFunctionBranchTeam",
    CREATE_EMPLOYEE_LEAD: "createEmployeeLead",
    UPDATE_EMPLOYEE_DETAILS_FROM_GROW: "updateEmployeeDetailsFromGrow",
    SWAP_TRUCK: "swapTruck",
    INSERT_TRUCK: "insertTruck",
    CUSTOMER_UNBLACKLIST: "customerUnblacklist",
    CUSTOMER_BLACKLIST: "customerBlacklist",
    UPDATE_CUSTOMER_DETAILS: "updateCustomerDetails",
    UPDATE_CUSTOMER_LEAD_DETAILS: "updateCustomerLeadDetails",
    EMAIL_MANUALLY_APPROVE: "emailManuallyApprove",
    EMPLOYEE_FAILOVER: "employeefailoverupsert",
    CREATE_CUSTOMER_LEAD: "createCustomerLead",
    ADD_CUSTOMER_USER: "addCustomerUser",
    DELETE_CUSTOMER_USER: "deleteCustomerUser",
    CONVERT_CUSTOMER_TO_LEAD: "convertCustomerToLead",
    REJECT_CUSTOMER: "rejectCustomer",
    TRUCK_MATCHING: "truckMatching",
    EXCEPTION_APPROVAL: "exceptionApproval",
    INSERT_AUTHORIZATION_ROLE: "insertAuthorizationRole",
    DELETE_AUTHORIZATION_ROLE: "deleteAuthorizationRole",
    REFRESH_INDENT_MATCHING: "refreshIndentMatching",
    FASTAG_MATCHING: "fastagMatching",
    INSERT_TRACKING_TRUCK: "insertTrackingTruck",
    EDIT_TRUCK_DETAILS: "editTruckDetails",
    TRIP_CONFIRMATION: "tripConfirmation",
    TRIP_ALLOCATION_WITH_TRUCK: 'tripAllocationWithTruck',
    UPDATE_INVALID_FASTAG_TRUCKS: "updateInvalidFastagTrucks",
    UPDATE_FASTAG_REQUEST_DETAILS: "updateFastagRequestDetails",
    TRIP_POD_CENTER_UPDATE: "tripPodCenterUpdate",
    UPDATE_CUSTOMER_USER: "updateCustomerUser",
    TRIP_ALLOCATION: "tripAllocation",
    LEAD_LOCATION_ANALYTICS: "leadLocationAnalytics",
    TRIP_RISK_EXCEPTION_CREATED: "trip.risk-exception.created",
    TRIP_RISK_EXCEPTION_APPROVED: "trip.risk-exception.approved",
    TRIP_RISK_EXCEPTION_REJECTED: "trip.risk-exception.rejected",
    INSERT_RAVEN_USER: 'insertRavenUser',
    INSERT_RAVEN_CHANNEL: 'insertRavenChannel',
    GROW_LOGIN_REQUEST:'growLoginRequest',
    TRIP_ALLOCATION_REMOVAL: 'tripAllocationRemoval',
    EMPLOYEE_CLICK_TO_CALL: 'employeeClickToCall',
    ACTIVATE_TRUCK:'activateTruck',
    PARTNER_BLACKLIST_REQUEST:'partnerBlacklistRequest',
    DELETE_MATCHING_LEAD: "deleteMatchingLead",
    EXCEPTION_REJECTED:'exceptionrejected'
   },
};
